import { View, Text, Dimensions, Image } from "react-native";
import React from "react";
import translate from "../../functions/translate";
import MyText from "../../components/custom/MyText";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  showBackButton,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useEffect } from "react";
import { babyBoy, babyGirl, newChild, width } from "../../imports";
import { femaleColor, gray, maleColor, primary, white } from "../../colors";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import UploadSection from "../../components/custom/UploadSection";
import MyButton from "../../components/custom/MyButton";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import addChild from "../../api/post/addChild";
import { refresh } from "../../redux/main/mainAction";
import Checkbox from "expo-checkbox";

export default function AddNewChild({ route }) {
  const navigation = useNavigation();

  const { params } = route;
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [canAdded, nowCanAdded] = useState(false);
  const [input, setInput] = useState({
    name: null,
    lastName: null,
    birthDay: null,
    birthMonth: null,
    birthYear: null,
    pregnancyDue: "47",
    childNo: null,
    height: null,
    weightGrams: null,
    weightKilos: null,
  });
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    if (isChecked) {
      setInput((prev) => ({ ...prev, pregnancyDue: null }));
    } else {
      setInput((prev) => ({ ...prev, pregnancyDue: "47" }));
    }
  }, [isChecked]);

  const addNewChild = () => {
    setLoading(true);
    let totalWeight = null;
    let height = null;
    if (
      (input.weightGrams === "" ||
        input.weightGrams === null ||
        input.weightGrams.length === 0) &&
      (input.weightKilos === "" ||
        input.weightKilos === null ||
        input.weightKilos.length === 0)
    ) {
    } else {
      let kilo = 0;
      let gram = 0;
      kilo = +input.weightKilos;
      gram = input.weightGrams === null ? 0 : +input.weightGrams;
      if (
        input.weightGrams === "" ||
        input.weightGrams === null ||
        input.weightGrams.length === 0
      ) {
        gram = 0;
      }
      if (
        input.weightKilos === "" ||
        input.weightKilos === null ||
        input.weightKilos.length === 0
      ) {
        kilo = 0;
      }
      totalWeight = kilo * 1000 + gram;
    }
    if (
      input.height === "" ||
      input.height === null ||
      input.height.length === 0
    ) {
    } else {
      height = +input.height;
    }
    addChild(
      image,
      input.name,
      input.lastName,
      `${input.birthYear}-${
        input.birthMonth < 10 ? "0" + input.birthMonth : input.birthMonth
      }-${input.birthDay < 10 ? "0" + input.birthDay : input.birthDay}`,
      parseInt(isChecked ? input.pregnancyDue : "47"),
      params.gender === "male" ? "boy" : "girl",
      parseInt(input.childNo),
      totalWeight,
      height,
      main.rtl ? true : false
    )
      .then(({ data }) => {
        setLoading(false);

        if (data.status === 200) {
          dispatch(refresh());
          navigation.pop(2);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    let allCompleted = true;
    Object.keys(input).forEach((key, index) => {
      if (input[key] === null || input[key].length === 0 || input[key] === "") {
        if (key !== "image" && key !== "weightGrams") {
          allCompleted = false;
        }
      }
    });
    if (allCompleted) {
      nowCanAdded(true);
    } else {
      nowCanAdded(false);
    }
  }, [input]);

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#EAFDDB"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);
  return (
    <KeyboardAwareScrollView
      keyboardShouldPersistTaps="handled"
      enableOnAndroid
      extraHeight={100}
      style={{ width: width }}
      contentContainerStyle={{ width: width }}
    >
      <View
        style={{
          width: width,
          alignItems: "center",
          flex: 1,
        }}
      >
        <View style={{ alignItems: "center", width: "100%" }}>
          <View
            style={{
              height: Dimensions.get("window").height,
              marginTop: -1 * Dimensions.get("window").height,

              width: width,
            }}
          ></View>
          <View style={{ alignItems: "center" }}>
            <View style={{}}>
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                  width: Dimensions.get("screen").width,
                  minHeight: 100,
                  flexDirection: "row",
                  paddingHorizontal: 10,
                }}
              >
                <View style={{ flex: 5 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      marginHorizontal: 10,
                      alignItems: "center",
                    }}
                  >
                    <MyText
                      style={{
                        fontSize: 24,
                        marginHorizontal: 2,
                        color: "#504E4E",
                      }}
                    >
                      {translate("add new child")}
                    </MyText>
                    <MyText
                      style={{
                        fontSize: 24,
                        marginHorizontal: 2,
                        color:
                          params?.gender === "male" ? maleColor : femaleColor,
                      }}
                    >
                      {`${
                        params?.gender === "male"
                          ? translate("boy")
                          : translate("girl")
                      }`}
                    </MyText>
                  </View>
                  <View
                    direction={main.rtl ? "rtl" : "ltr"}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  ></View>
                </View>
                <View style={{ flex: 2 }}>
                  <Image
                    source={params?.gender === "male" ? babyBoy : babyGirl}
                    style={{ width: "100%", height: 80 }}
                    resizeMode="contain"
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
        <View style={{ width: "85%" }}>
          <MyInputWithLabel
            noPlaceHolder={true}
            name="name"
            setInput={setInput}
            text={translate(
              params?.gender === "male" ? "your son name" : "your daughter name"
            )}
            style={{ marginVertical: 10, width: "100%" }}
            borderStyle={{
              borderColor: params?.gender === "male" ? maleColor : femaleColor,
            }}
            labelStyle={{
              color: params?.gender === "male" ? maleColor : femaleColor,
            }}
          />
          <MyInputWithLabel
            noPlaceHolder={true}
            name="lastName"
            setInput={setInput}
            text={translate(
              params?.gender === "male"
                ? "your son last name"
                : "your daughter last name"
            )}
            style={{ marginVertical: 10, width: "100%" }}
            borderStyle={{
              borderColor: params?.gender === "male" ? maleColor : femaleColor,
            }}
            labelStyle={{
              color: params?.gender === "male" ? maleColor : femaleColor,
            }}
          />
          <MyText
            style={{
              color: params?.gender === "male" ? maleColor : femaleColor,
            }}
          >
            {translate(
              params?.gender === "male"
                ? "your son birth date"
                : "your daughter birth date"
            )}
          </MyText>
          <View style={{ marginVertical: 15, flexDirection: "row" }}>
            <View
              style={{ alignItems: "center", flex: 1, marginHorizontal: 5 }}
            >
              <MyText>{translate("day")}</MyText>
              <MyInputWithLabel
                keyboardType="numeric"
                borderStyle={{
                  borderColor:
                    params?.gender === "male" ? maleColor : femaleColor,
                }}
                setInput={setInput}
                name="birthDay"
              />
            </View>
            <View
              style={{ alignItems: "center", flex: 1, marginHorizontal: 5 }}
            >
              <MyText>{translate("month")}</MyText>
              <MyInputWithLabel
                keyboardType="numeric"
                borderStyle={{
                  borderColor:
                    params?.gender === "male" ? maleColor : femaleColor,
                }}
                setInput={setInput}
                name="birthMonth"
              />
            </View>

            <View
              style={{ alignItems: "center", flex: 1, marginHorizontal: 5 }}
            >
              <MyText>{translate("year")}</MyText>
              <MyInputWithLabel
                keyboardType="numeric"
                borderStyle={{
                  borderColor:
                    params?.gender === "male" ? maleColor : femaleColor,
                }}
                setInput={setInput}
                name="birthYear"
              />
            </View>
          </View>
          <View>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Checkbox
                value={isChecked}
                onValueChange={setChecked}
                color={isChecked ? primary : undefined}
              />
              <MyText style={{ marginHorizontal: 5 }}>
                {translate("Premature birth")}
              </MyText>
            </View>
            {isChecked && (
              <MyText
                style={{
                  color: params?.gender === "male" ? maleColor : femaleColor,
                }}
              >
                {translate("pregnancy due date")}
              </MyText>
            )}
            {isChecked && (
              <View
                style={{
                  flexDirection: "row",
                  width: width / 2,
                  borderRadius: 15,
                  borderWidth: 1,
                  borderColor:
                    params?.gender === "male" ? maleColor : femaleColor,
                  alignItems: "center",
                  overflow: "hidden",
                  paddingHorizontal: 5,
                }}
              >
                <View style={{ flex: 1, height: 50 }}>
                  <MyInputWithLabel
                    keyboardType="numeric"
                    borderStyle={{
                      marginTop: -18,
                      borderWidth: 0,
                    }}
                    setInput={setInput}
                    name="pregnancyDue"
                  />
                </View>

                <View
                  style={{
                    height: 20,
                    width: 1,
                    backgroundColor: gray,
                    marginHorizontal: 5,
                  }}
                ></View>
                <MyText style={{}}>{translate("week")}</MyText>
              </View>
            )}
            <MyInputWithLabel
              keyboardType="numeric"
              noPlaceHolder={true}
              name="childNo"
              setInput={setInput}
              text={translate("children birth order")}
              style={{ marginVertical: 10, width: "40%" }}
              borderStyle={{
                borderColor:
                  params?.gender === "male" ? maleColor : femaleColor,
              }}
              labelStyle={{
                color: params?.gender === "male" ? maleColor : femaleColor,
              }}
            />
            <View style={{ marginTop: 20, width: "100%" }}>
              <MyText
                style={{
                  color: params?.gender === "male" ? maleColor : femaleColor,
                }}
              >
                {translate("your child birth weight")}
              </MyText>
              <View style={{ marginTop: 20, flexDirection: "row" }}>
                <View style={{ alignItems: "center" }}>
                  <MyText>{translate("kilograms")}</MyText>
                  <MyInputWithLabel
                    borderStyle={{
                      borderColor:
                        params?.gender === "male" ? maleColor : femaleColor,
                    }}
                    name="weightKilos"
                    keyboardType="number-pad"
                    style={{ width: width / 3 }}
                    setInput={setInput}
                    maxLength={3}
                  />
                </View>
                <View style={{ alignItems: "center", marginHorizontal: 10 }}>
                  <MyText>{translate("grams")}</MyText>
                  <MyInputWithLabel
                    borderStyle={{
                      borderColor:
                        params?.gender === "male" ? maleColor : femaleColor,
                    }}
                    name="weightGrams"
                    keyboardType="number-pad"
                    style={{ width: width / 3 }}
                    setInput={setInput}
                    maxLength={3}
                  />
                </View>
              </View>
            </View>
            <View style={{ marginTop: 20, width: "100%" }}>
              <MyText
                style={{
                  color: params?.gender === "male" ? maleColor : femaleColor,
                }}
              >
                {translate("your child birth height")}
              </MyText>
              <View
                style={{
                  marginTop: 20,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View style={{ alignItems: "center" }}>
                  <MyInputWithLabel
                    borderStyle={{
                      borderColor:
                        params?.gender === "male" ? maleColor : femaleColor,
                    }}
                    name="height"
                    keyboardType="number-pad"
                    style={{ width: width / 3 }}
                    setInput={setInput}
                    maxLength={3}
                  />
                </View>
                <MyText style={{ marginHorizontal: 10 }}>
                  {translate("cm")}
                </MyText>
              </View>
            </View>
          </View>
        </View>
        <View style={{ width: "80%", alignItems: "center" }}>
          <UploadSection
            setImage={setImage}
            textColor={params?.gender === "male" ? maleColor : femaleColor}
            borderColor={params?.gender === "male" ? maleColor : femaleColor}
          />
        </View>
        <View style={{ width: "90%" }}>
          <MyButton
            onPress={canAdded ? addNewChild : null}
            loading={loading}
            text={translate("add")}
            style={{
              backgroundColor: canAdded
                ? params?.gender === "male"
                  ? maleColor
                  : femaleColor
                : "#ddd",
              paddingVertical: 10,
            }}
            textStyle={{ fontSize: 20 }}
          />
        </View>
        <View style={{ height: 140 }}></View>
      </View>
    </KeyboardAwareScrollView>
  );
}
